export default __webpack_public_path__ + "homeCctv.307d027c.png";